<template>
    <div>
        <div class="affixDown" v-if="!renderToBtn && attachmentList.length > 0" style="margin-bottom: 10px">
            <affix-doc v-for="(item,index) in attachmentList"
                       :item.sync="item"
                       labelWidth="200px"
                       :index="index"
                       :key="index"
                       @refreshPdf="loadAtts"
                       :filingCBtn="attSignShow(item)&&filingCBtn"
                       @updateItem="updateItem"
                       :showModal="false"
                       :name="item.titleName"
                       :handleSignFunc="handleSignFunc"
            >
            </affix-doc>
        </div>
        <div v-else-if="renderToBtn && attachmentList.length > 0">
            <div v-for="(attfile,idx) in attachmentList" :key="'att_btn_group_'+idx" class="table-attbox" :title="attfile.name">
                <span style="margin-right:10px;">{{attfile.name}}</span>
                <el-button type="text" size="small" title="查看" @click="fileView(attfile)"><el-icon class="el-icon-view"></el-icon></el-button>
                <el-button type="text" size="small" title="下载" @click="fileDownload(attfile)"><el-icon class="el-icon-download"></el-icon></el-button>
            </div>
        </div>
        <p style="text-align: center" v-else>暂无附件数据</p>
    </div>
</template>

<script>
import {apiAttachmentGetDataByCodeAndEid} from "../../server/formRender";
import affixDoc from "./AffixDoc";

export default {
    name: "attachmentListItem",
    components: {
        affixDoc
    },
    props: {
        parentId: {
            type: String,
            required: true
        },
        paramMap: {
            type: Object,
            required: true
        },
        renderToBtn: {
            type: Boolean,
            required: false,
            default: false,
        },
        context: {
            type: Object,
            default: function () {
                return {}
            }
        },
        config: {
            type: Object,
            required: true,
            default: function () {
                return {atttype: '', types: "", showname: true}
            },
        },
        filingCBtn: { //控制签章按钮是否显示？
            type: Boolean,
            defalut: false
        },
        handleSignFunc: { //处理签章的方法
            type: Function,
            require: false,
        },
    },
    data() {
        return {
            filterMap: {},
            attachmentList: [],
            allowTypes: []
        }
    },
    created() {
        this.filterMap = {...this.paramMap}
        this.filterMap["entityId"] = this.parentId
        this.loadAtts();
        this.allowTypes = this.config.types ? this.types.split(",") : []
    },
    methods: {
        //更新附件
        updateItem(index, filePath){
            console.log('updateItem',index,filePath)
            const item = this.attachmentList[index]
            this.$set(this.attachmentList, index, { ...item, filePath: filePath})
        },
        //判断后端数据是否需要显示签章
        attSignShow(item){
            var mark = item.attributes
            if(mark && mark.showSignBtn){
                return true
            }
            return false
        },
        loadAtts() {
            apiAttachmentGetDataByCodeAndEid(this.config.atttype, this.parentId).then(({data}) => {
                if (data.code == "1") {
                    let resData = data.data;
                    if (resData.length > 0) {
                        let arr = [];
                        for (var i = 0; i < resData.length; i++) {
                            let attachmentObj = JSON.parse(JSON.stringify(resData[i]));
                            if (this.allowTypes.length > 0 && this.allowTypes.indexOf(attachmentObj.fileType) == -1) {
                                continue;
                            }
                            if (attachmentObj.attFiles.length > 0) {
                                for (var j = 0; j < attachmentObj.attFiles.length; j++) {
                                    let attachmentItem = JSON.parse(JSON.stringify(attachmentObj.attFiles[j]));
                                    attachmentItem.titleName = attachmentObj.name;
                                    attachmentItem.hideLable = (j == 0 ? false : true);
                                    arr.push(attachmentItem)
                                }
                            } else {
                                arr.push({
                                    titleName: attachmentObj.name,
                                    name: '',
                                    filePath: '',
                                    hideLable: false
                                })
                            }
                        }
                        this.attachmentList = arr;


                    } else {
                        this.attachmentList = [];
                    }
                } else {
                    this.attachmentList = [];
                }
            });
        },
        isAssetTypeAnImage(ext){
            let arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg','tif','tiff'];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnPDF(type) {
            return type.toLowerCase() === "pdf";
        },
        fileView(item){

            // 获取文件类型
            let type = item.name.substr(item.name.lastIndexOf(".")+1);
            let imgFlag = this.isAssetTypeAnImage(type);
            let pdfFlag = this.isAssetTypeAnPDF(type);

            if(pdfFlag){
                this.showSuitePDFView(item.filePath)
                return
            }

            if(imgFlag){
                window.open(item.filePath,item.name)
            }else{
                this.fileDownload(item);
            }
        },
        fileDownload(item){
            if(item.filePath){
                this.$http({
                    method:'get',
                    url:`/custom_att/pathEncode?path=${item.filePath}&filename=${item.name}`,
                    // responseType:'blob'
                }).then(res => {
                    if(res.data.code==='1'){
                        var a = document.createElement('a');
                        a.download = item.name;
                        a.target="_Blank";
                        a.href = res.data.data;
                        $("body").append(a);
                        a.click();
                        $(a).remove();

                    }else{

                        this.$message({
                            type:'error',
                            message:res.data.msg
                        })

                    }

                })
            }
        },

    }
}
</script>

<style lang="less" scoped>
.table-attbox{
    display: inline-block;
    margin-right: 5px;
    padding: 0px 5px;
    border-left: 1px solid #ccc;
}
.table-attbox:first-child{
    border-left:0px;
}
</style>